import { TimeRangesService } from './service';

const queryKey = ['get-time-ranges'];
export const useTimeRangesQuery = (
  debugString: string,
  timeRangesService: TimeRangesService
) => {
  const key = [...queryKey, ...timeRangesService.getDeps()];
  return {
    queryKey: key,
    queryFn: async () => {
      console.debug(`[useQuery] ${debugString}`, key);
      return timeRangesService.getTimeRanges();
    },
  };
};
